import { useMutation } from 'react-query';

import { MutationOptions } from '../../../types/Query';
import Api from '../../api/api';

export type TopicDto = {
  title: string;
  published: boolean;
};

export const createTopic = async (params: TopicDto[]) => {
  const [response, bodyOrError] = await Api.post('topics', params);

  if (!response.ok) {
    throw bodyOrError;
  }
  return bodyOrError;
};

export const useCreateTopic = (options?: MutationOptions<unknown, TopicDto[]>) =>
  useMutation('createTopic', createTopic, {
    ...options,
  });
